module.exports = __webpack_public_path__ + "static/media/gallery-3.a449ca7a.png";